export default __webpack_public_path__ + "static/media/CapaHelpIcon.8bb57f7a.svg";